var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { property } from "lit/decorators.js";
import { reset } from "../styles";
import { styles } from "./styles";
/**
 * `w-badge` is used for showing a small amount of non-interactive color-categorized metadata, like a status or count.
 *
 * @slot - The content of the badge, which is typically a short string like "New" or "4".
 */
class WarpBadge extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Controls the badge color treatment.
         * If omitted, the badge uses neutral styling without reflecting a `variant` attribute.
         * Accepted values are `neutral`, `info`, `positive`, `warning`, `negative`, `disabled`, `price`, and `sponsored`. If omitted, the badge uses neutral styling without reflecting a `variant` attribute.
         */
        this.variant = "neutral";
    }
    static { this.styles = [reset, styles]; }
    render() {
        return html `<div part="base"><slot></slot></div>`;
    }
}
__decorate([
    property({ type: String, reflect: true, useDefault: true })
], WarpBadge.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], WarpBadge.prototype, "position", void 0);
if (!customElements.get("w-badge")) {
    customElements.define("w-badge", WarpBadge);
}
export { WarpBadge };
//# sourceMappingURL=badge.js.map